export const getLocations = async (keyword) => {
  const url = 'https://www.routerunnersautotransport.com/zip-search-gm';
  const params = new URLSearchParams({
    keyword: keyword
  });

  const response = await fetch(`${url}?${params.toString()}`, {
    method: 'GET'
  });
  const body = await response.json();
  let locations = [];
  if (body) {
    locations = body
                  .map((obj) => {
                    let { zip } = obj;
                      if (
                          typeof obj.zip === 'string'
                          && obj.zip.length === 6
                          && obj.zip.charAt(0) === '0'
                      ) {
                        zip = obj.zip.substring(1);
                      }
                    return { ...obj, zip };
                  });
  }
  return locations;
};

export const getMake = async (year) => {
  const baseUrl = 'https://www.routerunnersautotransport.com/make-checker-gm';

  const params = new URLSearchParams({
    a: year,
    is_ajax: 1
  });

  const response = await fetch(`${baseUrl}?${params.toString()}`, {
    method: 'GET'
  });

  const body = await response.text();
  return body;
};

export const getModel = async (year, make) => {
  const baseUrl = 'https://www.routerunnersautotransport.com/model-checker-gm';

  const params = new URLSearchParams({
    a: year,
    b: make,
    is_ajax: 1
  });

  const response = await fetch(`${baseUrl}?${params}`);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.text();
};
